import React, { PureComponent } from 'react'
import { session } from 'gipsy-api'
import qs from 'qs'

export default function wrapper(Component) {
  class InviteAcceptPageContainer extends PureComponent {
    constructor(props) {
      super(props)
      const searchParams = qs.parse(window.location.search, { ignoreQueryPrefix: true })
      const invitationId = searchParams.invitationId
      const withEmail = searchParams.withEmail

      this.state = {
        noInvitation: !invitationId,
        displayEmailText: withEmail
      }

      if (invitationId) {
        window.sessionStorage.setItem('invitationId', invitationId)
      }
    }

    goToGoogleAuth = () => {
      session.getAuthURL('google', true).then(data => {
        window.sessionStorage.setItem('stateOAuth-google', data.state)
        window.sessionStorage.setItem('nonceOAuth-google', data.nonce)
        window.location.href = data.authURL
      })
    }

    goToMicrosoftAuth = () => {
      session.getAuthURL('microsoft', true).then(data => {
        window.sessionStorage.setItem('stateOAuth-microsoft', data.state)
        window.sessionStorage.setItem('nonceOAuth-microsoft', data.nonce)
        window.location.href = data.authURL
      })
    }

    render() {
      return (
        <Component
          onGoogleLogin={this.goToGoogleAuth}
          onMicrosoftLogin={this.goToMicrosoftAuth}
          noInvitation={this.state.noInvitation}
          displayEmailText={this.state.displayEmailText}
        />
      )
    }
  }
  return InviteAcceptPageContainer
}



// WEBPACK FOOTER //
// ./src/pages/inviteAcceptPage/container.js